/**
 * Timeout Manager - replaces window.__TIMEOUTS__ global
 * Manages timeout IDs for orders and calls to allow cancellation
 */

const timeouts = {
  orders: {
    initiated: {},
    pending: {},
  },
  calls: {
    initiated: {},
    pending: {},
  },
  call: null,
};

/**
 * Set a timeout for an order
 * @param {'initiated'|'pending'} type - Timeout type
 * @param {string} orderId - Order identifier
 * @param {Function} callback - Function to execute
 * @param {number} delay - Delay in milliseconds
 */
export const setOrderTimeout = (type, orderId, callback, delay) => {
  clearOrderTimeout(type, orderId);
  timeouts.orders[type][orderId] = setTimeout(callback, delay);
};

/**
 * Clear a timeout for an order
 * @param {'initiated'|'pending'} type - Timeout type
 * @param {string} orderId - Order identifier
 */
export const clearOrderTimeout = (type, orderId) => {
  if (timeouts.orders[type][orderId] !== undefined) {
    clearTimeout(timeouts.orders[type][orderId]);
    delete timeouts.orders[type][orderId];
  }
};

/**
 * Set a timeout for a call
 * @param {'initiated'|'pending'} type - Timeout type
 * @param {string} userId - User identifier
 * @param {Function} callback - Function to execute
 * @param {number} delay - Delay in milliseconds
 */
export const setCallTimeout = (type, userId, callback, delay) => {
  clearCallTimeout(type, userId);
  timeouts.calls[type][userId] = setTimeout(callback, delay);
};

/**
 * Clear a timeout for a call
 * @param {'initiated'|'pending'} type - Timeout type
 * @param {string} userId - User identifier
 */
export const clearCallTimeout = (type, userId) => {
  if (timeouts.calls[type][userId] !== undefined) {
    clearTimeout(timeouts.calls[type][userId]);
    delete timeouts.calls[type][userId];
  }
};

/**
 * Set the general call timeout
 * @param {Function} callback - Function to execute
 * @param {number} delay - Delay in milliseconds
 */
export const setGeneralCallTimeout = (callback, delay) => {
  clearGeneralCallTimeout();
  timeouts.call = setTimeout(callback, delay);
};

/**
 * Clear the general call timeout
 */
export const clearGeneralCallTimeout = () => {
  if (timeouts.call !== undefined && timeouts.call !== null) {
    clearTimeout(timeouts.call);
    timeouts.call = null;
  }
};
